import React, { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { IUserViewModel } from '../../../types/interfaces'
import { ICustomerViewModel, ITenantViewModel } from './../../../types/interfaces'
import CompanyWidget from './../CompanyWidget/CompanyWidget'
import './Companies.scss'
import SendReports from '../CompanyWidget/SendReports/SendReports'
import { WithVehicleOrderStats, withVehicleOrderStats } from '../../../hooks/useOrderStats'

interface ICount {
  current: number
  prev: number
  next: number
}

interface ICompaniesProps extends WithTranslation, WithVehicleOrderStats {
  tenants?: ITenantViewModel[]
  selectedManager?: string
  companies: ICustomerViewModel[]
  isTreeViewMode?: boolean
  // smallDisplay?: boolean
  isHomePage?: boolean
  isAdmin?: boolean
  isInternalUser?: boolean
  user?: IUserViewModel
  selectedCompany?: string
  showStats?: boolean
}

interface ICompaniesState {
  count: ICount
  hasMore: boolean
  sendReportTo?: ICustomerViewModel
}

const defAmount = 36

class Companies extends Component<ICompaniesProps, ICompaniesState> {
  constructor(props: ICompaniesProps) {
    super(props)

    this.state = {
      count: {
        current: 0,
        prev: 0,
        next: 0,
      },
      hasMore: true,
      sendReportTo: undefined,
    }

    this.getMoreData = this.getMoreData.bind(this)
  }

  public componentDidMount() {
    window.addEventListener('resize', this.getMoreData, false)
    window.addEventListener('scroll', this.getMoreData, false)

    this.getMoreData()
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.getMoreData, false)
    window.removeEventListener('scroll', this.getMoreData, false)
  }

  public componentDidUpdate(prevProps: Readonly<ICompaniesProps>, prevState: Readonly<ICompaniesState>) {
    if (this.state.count !== prevState.count) {
      this.getMoreData()
    }

    if (this.props.companies !== prevProps.companies) {
      this.setState({
        count: {
          current: 0,
          prev: 0,
          next: 0,
        },
        hasMore: true,
      })
    }
  }

  public render() {
    const { count } = this.state
    const { companies, t, user } = this.props
    return (
      <div id="homeBlock">
        <div className="wrapper grid-col-4">
          {companies.slice(0, count.current).map((customer, idx) => (
            <CompanyWidget
              tenant={this.props.tenants?.filter((q) => customer.tenantId?.toLowerCase() === q.id?.toLowerCase())[0]}
              selectedManager={this.props.selectedManager}
              key={idx}
              isTreeViewMode={this.props.isTreeViewMode}
              company={customer}
              // smallDisplay={this.props.smallDisplay}
              isHomePage={this.props.isHomePage}
              isAdmin={this.props.isAdmin}
              isInternalUser={this.props.isInternalUser}
              user={this.props.user}
              sendReport={() => this.setState({ sendReportTo: customer })}
              selectedCompany={this.props.selectedCompany ?? ''}
              vehicleOrderStats={this.props.vehicleOrderStats}
              showStats={this.props.showStats}
            />
          ))}
          {user?.isInternalUser && (
            <SendReports company={this.state.sendReportTo} close={() => this.setState({ sendReportTo: undefined })} />
          )}
        </div>

        <div className="infinite-scroll-msg">
          {companies.length > 0 && companies.length > count.current && <>{t('LOADING')}...</>}
        </div>
        <div className="infinite-scroll-msg">{companies.length === 0 && <>{t('NO_RESULTS_FOUND')}...</>}</div>
      </div>
    )
  }

  private loading: boolean = false

  private getMoreData() {
    const element = document.getElementById('homeBlock')

    if (
      (element?.getBoundingClientRect().bottom ?? 0) > window.innerHeight + 200 ||
      !this.state.hasMore ||
      this.loading
    ) {
      return
    }

    this.loading = true

    setTimeout(() => {
      const { count } = this.state
      const { companies } = this.props

      const current = count.current + count.next
      const next = companies.length - current >= defAmount ? defAmount : companies.length - current
      const hasMore = next > 0

      this.loading = false

      this.setState({
        count: { current: current, prev: count.current, next },
        hasMore,
      })
    }, 500)
  }
}

export default withTranslation('common')(withVehicleOrderStats(Companies))
